import { useState } from "react";

// Responsive image with fixed aspect ratio to prevent layout shift.
// object-cover keeps natural proportions without stretching/distortion.
export const SmartImage = ({
  src,
  alt,
  className = "",
  imgClassName = "",
  ratio = "aspect-[4/3]",
  eager = false,
}) => {
  const [loaded, setLoaded] = useState(false);
  return (
    <div className={`relative overflow-hidden bg-cool-gray ${ratio} ${className}`}>
      <img
        src={src}
        alt={alt}
        loading={eager ? "eager" : "lazy"}
        decoding="async"
        onLoad={() => setLoaded(true)}
        className={`h-full w-full object-cover transition-[opacity,transform] duration-700 ${
          loaded ? "opacity-100 scale-100" : "opacity-0 scale-105"
        } ${imgClassName}`}
      />
    </div>
  );
};
